import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';

/**
 * Returns if the provided folderId is present in mail store
 * @param folderId
 */
const isValidMailFolderId = (folderId: string): boolean => {
    const folder = getMailStore()?.folders?.folderTable?.get(folderId);
    return !!folder;
};

export default isValidMailFolderId;
